<template>
  <div class="fixed inset-0 bg-white flex items-center justify-center">
    <div class="flex flex-col items-center gap-4">
      <div
        class="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"
      ></div>
      <p class="text-gray-600">Loading...</p>
    </div>
  </div>
</template>
